import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import * as labels from "../components/localized/labels.js";

const get_url = (method) => {
    return `${process.env.REACT_APP_API_URL}/${method}`
}

const downloadFile = function (method, params) {

    var url = `${process.env.REACT_APP_API_URL}/${method}`;


    return new Promise(function (resolve, reject) {


        const { body, token } = params;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };

        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
        }

        var result = fetch(url, {
            //api allowed verb is POST
            method: 'POST',
            //headers
            headers: headers,
            //body
            body: body ? JSON.stringify(body) : null
        })
            .then(r => r.blob())
            .then(b => resolve(b))
            .catch(error => {
                reject(error);
            });
    });
}

const downloadFileGet = function (method, params = {}) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        var headers = {
            'Accept': 'application/octet-stream, */*',
        };

        if (params.user && params.user.token) {
            let token = params.user.token;
            
      

            headers["Authorization"] = token; // <--- Ora invia "Bearer <token>"
            
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else {
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        fetch(url, {
            method: 'GET',
            headers: headers
        })
        // ... il resto della funzione fetch rimane invariato ...
        .then(r => {
            if (r.headers.has('X-Auth-Token')) {
                const _user = JSON.parse(localStorage.getItem('user'));
                // Assicurati che anche qui il nuovo token venga salvato correttamente (opzionale)
                let newToken = r.headers.get("X-Auth-Token");
        
                _user.token = newToken;
                localStorage.setItem('user', JSON.stringify(_user));
            }
            
            // Check for 401 status (Unauthorized)
            if (r.status === 401 || r.status===403) {
                return r.json().then(data => {
                    return data;
                });
            }
            
            // For binary files, return blob instead of json
            return r.blob();
        })
        .then(blob => {
            resolve(blob);
        })
        .catch(error => {
            if (!params.silentMode) {
                // Logica di errore
            }
            reject(error);
        });
    });
}
const sendMessage = function (method, params) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        const { body, token } = params;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };


        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else { //in case of registration
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        var result = fetch(url, {
            //api allowed verb is POST
            method: 'POST',
            //headers
            headers: headers,
            //body
            body: body ? JSON.stringify(body) : null,

        })
            .then(r => {
                if (r.headers.has('X-Auth-Token')) {
                    const _user = JSON.parse(localStorage.getItem('user'));
                    _user.token = r.headers.get("X-Auth-Token");
                    localStorage.setItem('user', JSON.stringify(_user));
                }
                
                // Check for 401 status (Unauthorized)
                if (r.status === 401) {
                    return r.json().then(data => {
                        if (data.redirectLogin) {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            return Promise.reject(new Error('Unauthorized - redirecting to login'));
                        }
                        return data;
                    });
                }
                
                return r.json();
            })
            .then((data) => {
                resolve(data);

                if (data.error) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: data.error,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });

                    if (data.removeToken) {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                    }
                }

                // Handle redirectLogin even if there's no error field
                if (data.redirectLogin) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
            })
            .catch(error => {
                if (!params.silentMode) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: labels.getText()["ERROR_WHILE_CONNECTING_TO_SERVER"](),
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });
                }
                reject(error);
            });
    });
}

const sendGetRequest = function (method, params ) {
    return new Promise(function (resolve, reject) {
        var url = `${process.env.REACT_APP_API_URL}/${method}`;

        var headers = {
            "Content-Type": "application/json",
            'Accept': 'application/json',
        };

        if (params.user && params.user.token) {
            headers["Authorization"] = params.user.token;
            var lang = params.user && params.user._language ? `${params.user._language}-${params.user._language.toUpperCase()}` : "en"
            if (!params.user.language || !params.user.language) {
                lang = localStorage.getItem("active_language") || "en";
            }
            headers["Language"] = lang;
        }
        else {
            const lang = localStorage.getItem("active_language") || "en";
            headers["Language"] = lang;
        }

        fetch(url, {
            method: 'GET',
            headers: headers
        })
            .then(r => {
                if (r.headers.has('X-Auth-Token')) {
                    const _user = JSON.parse(localStorage.getItem('user'));
                    _user.token = r.headers.get("X-Auth-Token");
                    localStorage.setItem('user', JSON.stringify(_user));
                }
                
                // Check for 401 status (Unauthorized)
                if (r.status === 401) {
                    return r.json().then(data => {
                        if (data.redirectLogin) {
                            localStorage.removeItem("user");
                            window.location.href = "/login";
                            return Promise.reject(new Error('Unauthorized - redirecting to login'));
                        }
                        return data;
                    });
                }
                
                return r.json();
            })
            .then((data) => {
                resolve(data);

                if (data.error) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: data.error,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });

                    if (data.removeToken) {
                        localStorage.removeItem("user");
                        window.location.href = "/login";
                    }
                }

                // Handle redirectLogin even if there's no error field
                if (data.redirectLogin) {
                    localStorage.removeItem("user");
                    window.location.href = "/login";
                }
            })
            .catch(error => {
                if (!params.silentMode) {
                    withReactContent(Swal).fire({
                        title: "ERROR",
                        icon: "error",
                        text: error.message,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        showCloseButton: true,
                    });
                }
                reject(error);
            });
    });
}


export { sendMessage, downloadFile, get_url, sendGetRequest ,downloadFileGet };